const paths = {
  listQuotations: '/quotations/list',
  editQuotations: '/quotations/edit',
  followUpQuotations: '/quotations/followUp',
  webPageQuotations: '/quotations/add/:linkId/:operatorId',
  sendingDiscountQuotations: '/quotations/sending-discount-countdown/:linkId/:quotationId'
};

export default paths;
